import axios from 'axios';
import { AddressLink } from '../common/AddressLink';
import React from 'react';

const CartReviewStep = ({ cart, customer, subtotal, shipping, total, onRemoveItem, onNext, onBack }) => {
  return (
    <div className="max-w-4xl mx-auto">
      <h3 className="text-xl font-semibold mb-6">Review Your Order</h3>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Cart Items */}
        <div className="lg:col-span-2">
          <h4 className="text-lg font-medium mb-4">Items in Cart</h4>
          {cart.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              <p>No items in cart yet.</p>
              <p className="text-sm">Go back to add some products.</p>
            </div>
          ) : (
            <div className="space-y-4">
              {cart.map(item => (
                <div key={item.id} className="flex items-center justify-between p-4 border rounded-lg bg-white">
                  <div>
                    <h5 className="font-medium text-gray-900">{item.name}</h5>
                    <p className="text-sm text-gray-600 capitalize">{item.category}</p>
                    {item.petPersonalization && (
                      <p className="text-sm text-indigo-600 font-medium">
                        🐾 Personalized for: "{item.petPersonalization}"
                      </p>
                    )}
                  </div>
                  <div className="flex items-center space-x-4">
                    <span className="font-semibold text-lg">${item.price}</span>
                    <button
                      onClick={() => onRemoveItem(item.id)}
                      className="text-red-600 hover:text-red-800 text-sm px-2 py-1 rounded hover:bg-red-50"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Order Summary */}
        <div>
          <div className="bg-gray-50 p-6 rounded-lg">
            <h4 className="text-lg font-medium mb-4">Order Summary</h4>
            
            <div className="space-y-2 mb-4">
              <div className="flex justify-between">
                <span>Subtotal:</span>
                <span>${subtotal}</span>
              </div>
              <div className="flex justify-between">
                <span>Shipping:</span>
                <span>${shipping}</span>
              </div>
              <div className="border-t pt-2 flex justify-between font-semibold">
                <span>Total:</span>
                <span>${total}</span>
              </div>
            </div>

            <div className="text-sm text-gray-600 mb-4">
              <h5 className="font-medium mb-2">Shipping to:</h5>
              <p>{customer.name}</p>
              <p><AddressLink address={customer.address} city={customer.city} state={customer.state} postcode={customer.postcode} testId="cart-shipping-address-link" /></p>
              <p>{customer.city} {customer.state} {customer.postcode}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-between mt-8">
        <button
          onClick={onBack}
          className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
        >
          ← Back to Products
        </button>
        <button
          onClick={onNext}
          disabled={cart.length === 0}
          className={`px-6 py-2 rounded-lg font-medium ${
            cart.length > 0
              ? 'bg-indigo-600 hover:bg-indigo-700 text-white'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
        >
          Proceed to Checkout →
        </button>
      </div>
    </div>
  );
};

// Checkout Step Component

export default CartReviewStep;
